// extracted by mini-css-extract-plugin
module.exports = {"copyButton":"ControlledCopyButton-module--copyButton--TztUk","copied":"ControlledCopyButton-module--copied--7_nYE"};